<template>
  <div class="register">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>Welcome to Register !</span>
      </div>
      <el-form :model="registerForm" status-icon :rules="registerRules" ref="registerFormRef">
        <el-form-item prop="email">
          <el-input placeholder="Email" v-model="registerForm.email" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="invitationCode">
          <el-input
            placeholder="inviation code"
            v-model="registerForm.invitationCode"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            type="password"
            placeholder="new password"
            v-model.number="registerForm.password"
          ></el-input>
        </el-form-item>
        <el-form-item prop="confirmPassword">
          <el-input
            type="password"
            placeholder="confirm password"
            v-model.number="registerForm.confirmPassword"
          ></el-input>
        </el-form-item>
        <el-form-item prop="type">
          <el-checkbox
            v-model="isAgreementChecked"
            label="I have read and agree to the"
            name="type"
          ></el-checkbox>
          <el-button class="agreementBtn" @click="agreementDialogVisible = true">User Agreement</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="registerHandler('registerFormRef')">Register</el-button>
          <el-button @click="resetForm('registerFormRef')">Reset</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 协议内容弹窗 -->
    <el-dialog
      :title="agreementTitle"
      center
      :visible.sync="agreementDialogVisible"
      custom-class="agreementDialog"
      width="60%"
      top="30px" 
      :show-close="false"
    >
      <span v-html="agreementContent"></span>
      <span slot="footer" class="dialog-footer">
        <el-button  @click="cancel">Cancel</el-button>
        <el-button type="primary" @click="agree">confirm</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter your password'))
      } else {
        if (this.registerForm.password !== '') {
          callback()
        }
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter your password again'))
      } else if (value !== this.registerForm.password) {
        callback(new Error('Inconsistent passwords'))
      } else {
        callback()
      }
    }
    return {
      registerForm: {
        email: '',
        invitationCode: '',
        password: '',
        confirmPassword: '',
      },
      // 注册表单验证规则
      registerRules: {
        email: [
          {
            required: true,
            message: 'Please enter email address',
            trigger: 'blur',
          },
          {
            type: 'email',
            message: 'Please enter the correct email address',
            trigger: ['blur', 'change'],
          },
        ],
        invitationCode: [
          {
            required: true,
            message: 'Please enter the invitation code',
            trigger: 'blur',
          },
        ],
        password: [{ validator: validatePass, trigger: 'blur' }],
        confirmPassword: [{ validator: validatePass2, trigger: 'blur' }],
      },
      // 协议内容弹窗
      agreementDialogVisible: false,
      agreementContent: '',
      agreementTitle:null,
      // 协议，先勾选协议再注册
      isAgreementChecked: false,
    }
  },
  methods: {
    // 注册
    registerHandler(formName) {
      if (!this.isAgreementChecked)
        return this.$message.error('Please check the protocol')
      this.$refs[formName].validate((valid) => {
        if (!valid) return
        console.log(this.registerForm)
        this.$post('auth/checkRegister', this.registerForm).then(
          ({ data: res }) => {
            if (!res.ok) return this.$message.error(res.msg)
            this.$message.success(res.msg)
            console.log(123123)
            this.$router.push({
              name: 'registerinfo',
              params: this.registerForm,
            })
          }
        )
      })
    },

    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    agree(){

      this.agreementDialogVisible = false
      //勾选
      this.isAgreementChecked=true
      
    },
    cancel(){

      this.agreementDialogVisible = false

      
    }
  },
  created() {
    this.$get(`agreement/getAgreementByType/${'register'}`).then(
      ({ data: res }) => {
        this.agreementContent = res.data.context
        this.agreementTitle = res.data.title
        console.log(this.agreementContent)
      }
    )
  },
}
</script>

<style lang="less" scoped>
.register {
  // width: 30vw;
  .el-card {
    width: 480px;
    margin: 200px auto 0;
  }
  .el-form {
    margin: 0 auto;
  }
}
  .clearfix {
      font-size: 26px;
      font-weight: bold;
      color: #397EF5;
    }
/deep/.el-card__header {
  border: none;
  text-align: center;
}
.agreementBtn {
  padding: 0;
  border: none;
  font-size: 16px;
  color: #409eff;
  margin-left: 15px;
}
/deep/.agreementDialog {
  color: red;
  /deep/.el-dialog__body {
    height: 500px !important;
    overflow-y: scroll;
  }
}
</style>